/* eslint-disable */
import { useState, useEffect } from "react";
import { userService } from "../dependencyInjection";
import { unsubscribe } from "../../../../utils";
import { useAuth } from "../../../auth";

export function useIsAdmin(): [boolean | undefined] {
  const [isAdmin, setIsAdmin] = useState<boolean | undefined>(undefined);
  const [isAuth] = useAuth();
  useEffect(() => {
    const sub = userService.isAdmin$.subscribe((isAdmin) => {
      setIsAdmin(isAdmin);
    });
    return unsubscribe(sub);
  }, []);

  useEffect(() => {
    if (isAuth) {
      userService.checkAdminStatus();
    } else {
      setIsAdmin(false);
    }
  }, [isAuth]);

  return [isAdmin];
}
